import React from 'react';
import { Spinner } from 'react-bootstrap';
import useIdClient from './hooks';
import {
  ArrowLeft, Delete, Pencil, Poin,
} from '../../../../components/atoms/icons';
import './style.scss';
import Button from '../../../../components/molecules/buttons';
import Cards from '../../../../components/molecules/cards';
import RenderPendingInvoices from './RenderPendingInvoices';
import RenderPendingCoffeeInvoices from './RenderPendingCoffeeInvoices';
import RenderContactPerson from './RenderContactPerson';
import RenderPartners from './RenderPartners';
import RenderVendingMachine from './RenderVendingMachine';
import Modal from '../../../../components/organisms/modals';
import { successUpdateMsg } from '../../../../components/atoms/const';

function ClientsDetail(): React.ReactElement {
  const {
    onNavigateBack, clientById, navigateToViewCoffeeInvoices, navigateToViewCoffeeInvoiceDetail, navigateToViewPaidInvoices, navigateToAddContact, navigateToAddPartner,
    handleDeleteContact, loadingDeleteContact, resultUpdate, afterUpdate, clientId, invoiceList,
    paymentData, coffeePaymentData, invoicesLoading, coffeeInvoiceList, coffeeInvoicesLoading, handleDeletePartner, loadingDeletePartner, formikPayInvoice,
    loadingPayInvoice, formikPayCoffeeInvoice, loadingPayCoffeeInvoice, afterCoffeeInvoiceUpdate, navigateToEditClient, afterDeleteClient, handleDeleteClient, deleteClientLoad,
  } = useIdClient();

  const renderModalBody = ():string => {
    if (!resultUpdate) return 'Are you sure to remove this client?';
    return successUpdateMsg.SUCCESS_DELETE_CLIENT_MSG;
  };

  return (
    <div>
      <div className="p-4 px-xl-5 pb-0">
        <div className="d-flex justify-content-between" style={{ marginBottom: '35px' }}>
          <div className="d-flex align-items-start">
            <button
              onClick={onNavigateBack}
              type="button"
              className="border-0 bg-transparent"
              style={{ marginTop: '8px' }}
            >
              <ArrowLeft />
            </button>
            <div className="ms-3">
              <h4 className="fw-bold mt-2 mb-3">
                {clientById?.name ?? <Spinner size="sm" animation="border" />}
              </h4>
              <div className="d-flex fz-14">
                <Poin width={20} />
                <span className="text-secondary ms-2">{clientById?.address ?? <Spinner size="sm" animation="border" />}</span>
              </div>
            </div>
          </div>
          <div className="d-flex mt-1">
            <div className="me-3">
              <Button.CircleIcon
                id="editClient"
                type="button"
                icon={<Pencil width={16} color="white" />}
                onClick={navigateToEditClient}
                isButton
              />
            </div>
            <Modal.Default
              cancelLabel="No"
              submitLabel="Yes"
              title="Delete Client"
              body={renderModalBody()}
              isLoading={deleteClientLoad}
              result={resultUpdate}
              onAfterResult={afterDeleteClient}
              onSubmit={handleDeleteClient}
              size="sm"
            >
              <Button.CircleIcon id="deleteClient" type="button" icon={<Delete width={15} color="white" />} />
            </Modal.Default>
          </div>
        </div>
        <div className="d-flex">
          <Cards.Payment
            pay={invoicesLoading ? <Spinner size="sm" animation="border" /> : paymentData.received}
            status="Payment Received"
            background={1}
            className="me-2"
          />
          <Cards.Payment
            pay={invoicesLoading ? <Spinner size="sm" animation="border" /> : paymentData.pending}
            status="Payment Pending"
            background={3}
          />
        </div>
      </div>
      <RenderPendingInvoices
        onNavigate={navigateToViewPaidInvoices}
        pendingList={invoiceList}
        isLoading={invoicesLoading}
        formik={formikPayInvoice}
        afterUpdate={afterUpdate}
        resultUpdate={resultUpdate}
        loadingUpdate={loadingPayInvoice}
        paymentData={{ bill: paymentData.pending, paid: paymentData.received }}
      />
      <RenderPendingCoffeeInvoices
        onNavigate={navigateToViewCoffeeInvoices}
        onViewDetail={navigateToViewCoffeeInvoiceDetail}
        pendingList={coffeeInvoiceList}
        isLoading={coffeeInvoicesLoading}
        formik={formikPayCoffeeInvoice}
        afterUpdate={afterCoffeeInvoiceUpdate}
        resultUpdate={resultUpdate}
        loadingUpdate={loadingPayCoffeeInvoice}
        paymentData={{ bill: coffeePaymentData.pending, paid: coffeePaymentData.received }}
      />
      <div className="w-100 bg-stroke mt-4 mb-4" style={{ height: '7px' }} />
      <div className="w-100 mb-4">
        <RenderContactPerson
          clientId={clientId!}
          onNavigate={navigateToAddContact}
          data={clientById?.contactPerson ?? []}
          afterDelete={afterUpdate}
          resultDelete={resultUpdate}
          handleDelete={handleDeleteContact}
          loadingDelete={loadingDeleteContact}
        />
      </div>
      <div className="w-100 bg-stroke mt-4 mb-4" style={{ height: '7px' }} />
      <div className="w-100 mb-4">
        <RenderPartners
          onNavigate={navigateToAddPartner}
          data={clientById?.partners}
          clientId={clientId!}
          loadingDelete={loadingDeletePartner}
          handleDelete={handleDeletePartner}
          resultDelete={resultUpdate}
          afterDelete={afterUpdate}
        />
      </div>
      <div className={clientById?.vmList?.length ? 'mb-4' : 'd-none'}>
        <div className="w-100 bg-stroke mt-4 mb-4" style={{ height: '7px' }} />
        <RenderVendingMachine data={clientById?.vmList ?? []} />
      </div>
    </div>
  );
}

export default ClientsDetail;
